import { Component, OnChanges, Input } from '@angular/core';

import { Color } from 'ng2-charts';
import { UiService } from '@services/ui.service';

import { MonitoringResultData  } from '@classes/monitoring/monitoring-result-data' ;
import { MonitoringResultGraph } from '@classes/monitoring/monitoring-result-graph';

@Component({
  selector: 'app-monitoring-graph-bar-vertical',
  templateUrl: './monitoring-graph-bar-vertical.component.html',
  styleUrls: ['./monitoring-graph-bar-vertical.component.scss']
})
export class MonitoringGraphBarVerticalComponent implements OnChanges {

    @Input() graph: MonitoringResultGraph;

    labels: string[];
    values: number[];

    options: any;

    readonly colors: Color[] = [
        {
            borderColor: 'black',
            backgroundColor: 'rgba(186, 24, 24)'
        }
    ];

    constructor (private uiSrv: UiService) {}

    ngOnChanges () {
        this.options = this.getOptions(this.graph.format);

        var datas = this.graph.datas
            .filter(data => data.value != 0)
            .sort((a, b) => b.value - a.value);
        if (datas.length > 11) {
            var other = new MonitoringResultData();
            other.label = this.uiSrv.translate('monitoring.graphs.others.shortLabel');
            other.value = datas.slice(10).reduce((sum, current) => sum + current.value, 0);
            datas = datas.slice(0, 9);
            datas.push(other);
        }

        this.labels = datas.map(i => i.label);
        this.values = datas.map(i => i.value);

        if (this.graph.format === 'percent') {
            const sum = this.values.reduce((a, b) => a + b, 0);
            if (sum === 0) {
                this.values = [];
            } else {
                this.values = this.values.map(i => 100 * i / sum);
            }
        }
    }

    private getOptions (format: string): any {
        return {
            scaleShowVerticalLines: false,
            responsive: true,
            legend: {
                display: false,
                position: "bottom",
                labels: {
                    boxWidth: 60,
                    fontSize: 30
                }
            },
            scales: {
                xAxes: [{
                    stacked: false
                }],
                yAxes: [{
                    stacked: false,
                    ticks: {
                        beginAtZero: true
                    },
                    scaleLabel: {
                        display: format === 'percent',
                        labelString: this.uiSrv.translate('monitoring.graphs.percent.shortLabel')
                    }
                }]
            },
            fillColor: "rgba(220,220,220,0.4)"
        };
    }

}
